import React from "react";
import { RenderKilogramo } from "../../../../Utils/renderField/renderReadField";

const SIN_PADRE = "Sin producto padre";

// Con onCambiarObservacion la columna de observaciones se digita, y el valor
// sale del borrador que lleva la pantalla; sin él se muestra lo que quedó
// guardado en el cierre
export const ExistenciaBodegaTable = ({
    padres = [],
    totales = {},
    observaciones = {},
    onCambiarObservacion,
}) => {
    const editable = !!onCambiarObservacion;

    if (!padres.length) {
        return (
            <div className="text-center py-5">
                <h3>No hay datos disponibles</h3>
            </div>
        );
    }

    return (
        <div className="new-table-wrapper my-4">
            <table className="table-striped-v2">
                <thead>
                    <tr>
                        <th>Producto padre</th>
                        <th>Tipo de producto</th>
                        <th className="text-right">Kg conforme</th>
                        <th className="text-right">Kg no conforme</th>
                        <th className="text-right">Total kilos secos</th>
                        <th className="text-right">Sub total padre</th>
                        <th>Observaciones</th>
                    </tr>
                </thead>

                <tbody>
                    {padres.map((padre) => (
                        <React.Fragment key={padre.padre_producto_terminado_id}>
                            {padre.productos.map((producto, index) => (
                                <tr
                                    key={producto.producto_id}
                                    className="cell-border-bottom"
                                >
                                    {index === 0 && (
                                        <td
                                            className="text-nowrap text-center reporte-inventarios__padre-cell cell-border-right"
                                            rowSpan={padre.productos.length}
                                        >
                                            {padre.padre_producto_terminado ||
                                                SIN_PADRE}
                                        </td>
                                    )}
                                    <td>{producto.producto}</td>
                                    <td className="text-right text-nowrap">
                                        <RenderKilogramo
                                            value={producto.kg_conforme}
                                            decimalScale={3}
                                        />
                                    </td>
                                    <td className="text-right text-nowrap">
                                        <RenderKilogramo
                                            value={producto.kg_no_conforme}
                                            decimalScale={3}
                                        />
                                    </td>
                                    <td className="text-right text-nowrap cell-border-right">
                                        <RenderKilogramo
                                            value={producto.kg_total}
                                            decimalScale={3}
                                        />
                                    </td>
                                    {index === 0 && (
                                        <td
                                            className="text-right text-nowrap reporte-inventarios__padre-cell cell-border-right"
                                            rowSpan={padre.productos.length}
                                        >
                                            <RenderKilogramo
                                                value={padre.kg_subtotal}
                                                decimalScale={3}
                                            />
                                        </td>
                                    )}
                                    <td style={{ minWidth: "220px" }}>
                                        {editable ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Opcional"
                                                value={
                                                    observaciones[
                                                        producto.producto_id
                                                    ] || ""
                                                }
                                                onChange={(e) =>
                                                    onCambiarObservacion(
                                                        producto.producto_id,
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        ) : (
                                            producto.observaciones
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </React.Fragment>
                    ))}

                    <tr className="totales-row">
                        <td className="fw-bold" colSpan={2}>
                            TOTAL
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_conforme}
                                decimalScale={3}
                            />
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_no_conforme}
                                decimalScale={3}
                            />
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_total}
                                decimalScale={3}
                            />
                        </td>
                        {/* la suma de los subtotales es el mismo total, va
                            repetida igual que en el Excel */}
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_total}
                                decimalScale={3}
                            />
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
